import { PickType } from '@nestjs/swagger';
import { RegionTimeWindowCreatableInterface } from '../interfaces/region-time-window-creatable.interface';
import { RegionTimeWindowDto } from './region-time-window.dto';

export class RegionTimeWindowCreateDto
  extends PickType(RegionTimeWindowDto, [
    'windowStartTime',
    'windowEndTime',
    'regionId',
    'regionTimeType',
  ])
  implements RegionTimeWindowCreatableInterface {}
